
class selectDateDialogController implements angular.IOnInit {
  public invalidDates: Date[]

  public selectedDate: Date;
  public minDate: Date = new Date(Date.UTC(2018, 0));
  public maxDate: Date = new Date(Date.UTC(new Date().getFullYear(), 11, 31));

  /** @ngInject */
  constructor(private $mdDialog: angular.material.IDialogService, private $scope: angular.IScope) { }

  $onInit(): void {
    (this.$scope as any).isSelectableDate = this.isSelectableDate.bind(this);
  }

  public isSelectableDate(date: Date) {
    return !this.invalidDates.find(d => d.getMonth() === date.getMonth() &&
      d.getFullYear() === date.getFullYear())
  }

  public save() {
    // Unimpressed by default browser behaviour
    const actualDate = new Date(Date.UTC(this.selectedDate.getFullYear(), this.selectedDate.getMonth() + 1, 0));
    this.$mdDialog.hide(actualDate);
  }

  public cancel() {
    this.$mdDialog.cancel();
  }
}

export const selectDateDialog: angular.IComponentOptions = {
  controller: selectDateDialogController,
  template: require('./selectDate.dialog.html'),
  bindings: {
    invalidDates: '<'
  }
}



// WEBPACK FOOTER //
// ./src/app/cmodel/cmodel.marketAnalysis/selectDateDialog/selectdate.dialog.ts